import React, { useState } from "react";
import { omLogo } from "../../assets/images";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setAlertDialog } from "../../js/reducers/alertDialog";
import { setSnackbar } from "../../js/reducers/snackbar";
import { OAuth as OAuthActions } from "../../js/actions";

import {
  Typography,
  TextField,
  Button,
  InputAdornment,
  IconButton,
  Checkbox,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { FooterTabs } from "../index";

const useStyles = makeStyles((theme) => ({
  parentDiv: {
    width: "100vw",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "1.5rem",
    boxSizing: "border-box",
  },
  loginCard: {
    position: "relative",
    width: "100%",
    maxWidth: "420px",
    padding: "2rem",
    borderRadius: "24px",
    background: "rgba(255, 255, 255, 0.72)",
    backdropFilter: "blur(22px)",
    WebkitBackdropFilter: "blur(22px)",
    border: "1px solid rgba(255, 255, 255, 0.6)",
    boxShadow:
      "0 20px 60px rgba(3, 46, 79, 0.28), inset 0 1px 0 rgba(255,255,255,0.6)",
    animation: "$cardFadeIn 0.6s ease",
    [theme.breakpoints.down("xs")]: {
      padding: "2rem 1.5rem",
      borderRadius: "20px",
    },
  },
  "@keyframes cardFadeIn": {
    from: { opacity: 0, transform: "translateY(24px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  logoWrap: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "1.5rem",
  },
  logo: {
    height: "64px",
    width: "auto",
    objectFit: "contain",
  },
  title: {
    color: "#005691",
    textAlign: "center",
    fontWeight: 700,
    marginBottom: "0.5rem",
  },
  subtitle: {
    textAlign: "center",
    color: "#5a6b78",
    marginBottom: "1.5rem",
    fontSize: "0.9rem !important",
  },
  field: {
    marginBottom: "1.25rem",
    "& .MuiInputBase-root": {
      margin: "0 !important",
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: "14px !important",
      background: "rgba(255,255,255,0.65)",
      transition: "box-shadow 0.25s ease, background 0.25s ease",
      "& fieldset": {
        borderColor: "rgba(11, 60, 93, 0.15)",
      },
      "&:hover fieldset": {
        borderColor: "rgba(3, 169, 243, 0.5)",
      },
      "&.Mui-focused": {
        background: "rgba(255,255,255,0.95)",
        boxShadow: "0 6px 18px rgba(3, 169, 243, 0.18)",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#03A9F3",
        borderWidth: "1.5px",
      },
    },
    "& .MuiOutlinedInput-input": {
      padding: "16.5px 2px",
      fontSize: "0.90em !important",
    },
  },
  inputIcon: {
    color: "#7a8b96",
  },
  buttonRow: {
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    marginTop: "1.5rem",
  },
  cancelButton: {
    width: "30%",
    padding: "0.6rem",
    borderRadius: "14px",
    fontWeight: 700,
    fontSize: "0.95rem !important",
    letterSpacing: "0.03em",
    textTransform: "none",
    color: "#0B4759",
    background: "rgba(255,255,255,0.8)",
    border: "1px solid rgba(11, 60, 93, 0.2)",
    "&:hover": {
      background: "rgba(255,255,255,1)",
      border: "1px solid rgba(11, 60, 93, 0.4)",
    },
  },
  submitButton: {
    width: "30%",
    padding: "0.6rem",
    borderRadius: "14px",
    fontWeight: 700,
    fontSize: "0.95rem !important",
    letterSpacing: "0.03em",
    textTransform: "none",
    color: "#fff",
    background: "linear-gradient(135deg, #0288d1 0%, #0B4759 100%)",
    "&:hover": {
      background: "linear-gradient(135deg, #03A9F3 0%, #0B4759 100%)",
    },
  },
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    marginBottom: "0.5rem",
  },
  checkboxLabel: {
    fontSize: "0.8rem !important",
    color: "#5a6b78",
    whiteSpace: "nowrap",
    marginLeft: "0.5rem",
    "& em": {
      textDecoration: "underline",
      cursor: "pointer",
      color: "#0288d1",
      fontStyle: "normal",
      fontWeight: 600,
      "&:hover": {
        color: "#0B4759",
      },
    },
  },
}));

const NewUserCard = ({ id }) => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [passwordHelper, setPasswordHelper] = useState("");
  const [newPasswordHelper, setNewPasswordHelper] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [termsOfUse, setTermsOfUse] = useState(false);
  const [privacyPolicy, setPrivacyPolicy] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPrivacy, setOpenPrivacy] = React.useState(false);

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);
  const handleClickShowNewPassword = () => setShowNewPassword(!showNewPassword);
  const handleMouseDownNewPassword = () => setShowNewPassword(!showNewPassword);

  const history = useHistory();

  const onChange = (event) => {
    let valid;
    switch (event.target.id) {
      case "password":
        setPassword(event.target.value);
        valid = /(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
          event.target.value
        );
        if (!valid && event.target.value.length !== 0) {
          setPasswordHelper(
            "The password must contain at least 1 number,1 special character(!,@,#,$,%,^,&,*) and must be at least 8 characters in length"
          );
        } else {
          setPasswordHelper("");
        }
        break;
      case "newPassword":
        setNewPassword(event.target.value);
        valid = /(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/.test(
          event.target.value
        );
        if (!valid && event.target.value.length !== 0) {
          setNewPasswordHelper(
            "The password must contain at least 1 number,1 special character(!,@,#,$,%,^,&,*) and must be at least 8 characters in length"
          );
        } else if (password !== event.target.value) {
          setNewPasswordHelper(
            "The above password and the confirmation password must be same."
          );
        } else {
          setNewPasswordHelper("");
        }
        break;
      case "termsOfUse":
        setTermsOfUse(event.target.checked);
        break;
      case "privacyPolicy":
        setPrivacyPolicy(event.target.checked);
        break;
      default:
        break;
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClickPrivacyOpen = () => {
    setOpenPrivacy(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handlePrivacyClose = () => {
    setOpenPrivacy(false);
  };

  const submit = () => {
    let hasError = false;
    if (password.length === 0) {
      setPasswordHelper("Please enter password");
      hasError = true;
    } else if (passwordHelper.length !== 0) {
      hasError = true;
    }
    if (newPassword.length === 0) {
      setNewPasswordHelper("Please enter confirm password");
      hasError = true;
    } else if (newPasswordHelper.length !== 0) {
      hasError = true;
    }
    if (!termsOfUse || !privacyPolicy) {
      dispatch(setSnackbar(true, "error", "Please accept the terms and conditions and acknowledge the privacy policy."));
      hasError = true;
    }
    if (hasError) return;

    dispatch(OAuthActions.register(id, password)).then(function (success) {
      if (success["error"] === undefined) {
        dispatch(
          setAlertDialog(
            true,
            null,
            "success",
            "New Password",
            "New Password set successfully. Note: Please contact the administrator to activate your account, if you are a new user.",
            "OK",
            ""
          )
        );
        history.push("/login");
      } else dispatch(setAlertDialog(true, null, "error", "New Password", "New Password set is unsuccessful.\nDetails Of Failure: " + success.message, "OK", ""));
    });
  };

  return (
    <div className={classes.parentDiv}>
      <div className={classes.loginCard}>
        <div className={classes.logoWrap}>
          <img src={omLogo} alt="login_logo" className={classes.logo} />
        </div>

        <Typography variant="h4" className={classes.title}>
          New Password
        </Typography>

        <Typography className={classes.subtitle}>
          Please enter your new password
          <br />
          This will henceforth be used as the password to your account
        </Typography>

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={passwordHelper.length !== 0}
          helperText={passwordHelper}
          id="password"
          placeholder="Password"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(event) => onChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <TextField
          fullWidth
          required
          variant="outlined"
          className={classes.field}
          error={newPasswordHelper.length !== 0}
          helperText={newPasswordHelper}
          id="newPassword"
          placeholder="Confirm Password"
          type={showNewPassword ? "text" : "password"}
          value={newPassword}
          onChange={(event) => onChange(event)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LockOutlinedIcon className={classes.inputIcon} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowNewPassword}
                  onMouseDown={handleMouseDownNewPassword}
                  edge="end"
                >
                  {showNewPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <div className={classes.checkboxRow} style={{ marginTop: "0.3rem" }}>
          <Checkbox
            id="termsOfUse"
            checked={termsOfUse}
            onChange={(event) => onChange(event)}
            color="primary"
          />
          <Typography className={classes.checkboxLabel}>
            I accept the{" "}
            <em onClick={handleClickOpen}>terms and conditions</em>
          </Typography>
          <FooterTabs clickValue={3} open={open} onClose={handleClose} />
        </div>

        <div className={classes.checkboxRow}>
          <Checkbox
            id="privacyPolicy"
            checked={privacyPolicy}
            onChange={(event) => onChange(event)}
            color="primary"
          />
          <Typography className={classes.checkboxLabel}>
            I acknowledge the{" "}
            <em onClick={handleClickPrivacyOpen}>privacy policy</em>
          </Typography>
          <FooterTabs
            clickValue={1}
            open={openPrivacy}
            onClose={handlePrivacyClose}
          />
        </div>

        <div className={classes.buttonRow}>
          <Button
            size="large"
            variant="outlined"
            className={classes.cancelButton}
            onClick={() => {
              setNewPassword("");
              setPassword("");
              history.push("/login");
            }}
          >
            Cancel
          </Button>
          <Button
            size="large"
            variant="contained"
            className={classes.submitButton}
            onClick={submit}
          >
            Submit
          </Button>
        </div>
      </div>
    </div>
  );
};

export default React.memo(NewUserCard);
